export const short = (a, n = 4) => (a ? `${a.slice(0, 2 + n)}…${a.slice(-n)}` : "");

export const fmtUsd = (v, compact = true) => {
  if (v === null || v === undefined || Number.isNaN(v)) return "—";
  if (Math.abs(v) < 0.01 && v !== 0) return `$${Number(v).toPrecision(3)}`;
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", notation: compact && Math.abs(v) >= 1e5 ? "compact" : "standard", maximumFractionDigits: Math.abs(v) >= 1 ? 2 : 6 }).format(v);
};

export const fmtNum = (v, max = 6) => {
  if (v === null || v === undefined || v === "" || Number.isNaN(Number(v))) return "—";
  const n = Number(v);
  if (n !== 0 && Math.abs(n) < 1e-6) return n.toExponential(3);
  return new Intl.NumberFormat("en-US", { maximumFractionDigits: max }).format(n);
};

export const fmtPct = (v) => (v === null || v === undefined ? "—" : `${v > 0 ? "+" : ""}${Number(v).toFixed(2)}%`);

export const timeAgo = (iso) => {
  const s = Math.max(1, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
  if (s < 60) return `${s}s`;
  if (s < 3600) return `${Math.floor(s / 60)}m`;
  if (s < 86400) return `${Math.floor(s / 3600)}h`;
  return `${Math.floor(s / 86400)}d`;
};

export const isAddress = (a) => /^0x[0-9a-fA-F]{40}$/.test(a || "");
